import q from "./design-system.es299.js";
import x from "./design-system.es51.js";
import { resolveComponent as w, openBlock as d, createElementBlock as a, normalizeClass as u, createVNode as S, withCtx as O, createElementVNode as o, withDirectives as m, vShow as c, createTextVNode as r, Fragment as P, renderList as K, withModifiers as i, toDisplayString as f, createCommentVNode as y, withKeys as h, createBlock as B, renderSlot as I } from "vue";
/* empty css                    */
import M from "./design-system.es128.js";
import N from "./design-system.es58.js";
import T from "./design-system.es95.js";
import D from "./design-system.es116.js";
/* empty css                    */
const _ = {
  name: "DsSelectField",
  components: {
    Dropdown: x,
    Icon: N,
    Spinner: T
  },
  mixins: [q],
  props: {
    /**
     * The vmodel value that is selected
     */
    modelValue: [String, Number, Object, Boolean],
    /**
     * Array of value label options
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * Label to render above the select field when active
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * HTML select element name
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Placeholder text for when the select is empty
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Prevents the user from changing the selection
     */
    readonly: {
      type: Boolean,
      default: !1
    },
    /**
     * Shows a loading spinner inside the select field and menu
     */
    loading: Boolean,
    /**
     * Required field for validation purposes
     */
    required: Boolean,
    /**
     * Controls visualization of rendering form validation error states
     */
    submitted: Boolean,
    /**
     * Force the error state to show if parent is controlling it
     */
    forceInvalid: Boolean,
    /**
     * Show selected label even if value is null/false/empty
     */
    allowNull: Boolean,
    /**
     * By default the vmodel output is the full selected object from options, but with this it\'s just the value itself
     */
    bindValueOnly: Boolean,
    /**
     * The name of the property in your options array that contains the label to display
     */
    labelProp: {
      type: String,
      default: "label"
    },
    /**
     * The name of the property in your options array that contains the value
     */
    valueProp: {
      type: String,
      default: "value"
    },
    /**
     * Text to display where there are no results
     */
    noResultsLabel: String,
    /**
     * If you want to compare selected properties against more than one value field
     */
    selectProperties: Array,
    /**
     * Pin the bottom of the menu to the bottom of the viewport for really long menus
     */
    pinBottom: Boolean,
    /**
     * Enables dense mode
     */
    dense: Boolean
  },
  emits: ["update:modelValue"],
  setup() {
    return { i18n: D() };
  },
  data() {
    return {
      active: !1,
      selected: this.modelValue,
      firstTimeOpen: !1
    };
  },
  computed: {
    showError() {
      return !!(this.$slots.error && this.submitted);
    },
    showInvalid() {
      return this.submitted && this.invalid;
    },
    hasSelected() {
      return this.selected || this.allowNull;
    },
    dropdownOptions() {
      return this.options || [];
    },
    selectedLabel() {
      if (this.hasSelected) {
        if (typeof this.selected == "object" || this.bindValueOnly) {
          const t = this.dropdownOptions.find((e) => this.isSelectedOption(e));
          return t && t[this.labelProp] || "";
        }
        return this.selected;
      }
      return "";
    },
    selectedIndex() {
      return this.hasSelected ? typeof this.selected == "object" || this.bindValueOnly ? this.dropdownOptions.findIndex((t) => this.isSelectedOption(t)) : this.dropdownOptions.findIndex((t) => typeof t == "object" ? t[this.valueProp] === this.selected : t === this.selected) : -1;
    },
    invalid() {
      return this.required && !this.hasSelected || this.forceInvalid;
    },
    tabIndex() {
      return this.readonly ? -1 : 0;
    }
  },
  watch: {
    dropdownOptions: {
      handler(t) {
        this.dropdownKeys_optionsModel = t;
      },
      deep: !0
    },
    modelValue: {
      handler(t) {
        this.selected = t;
      },
      deep: !0
    }
  },
  created() {
    this.dropdownKeys_optionsModel = this.dropdownOptions, this.selectedIndex !== -1 && this.$nextTick(() => {
      this.dropdownKeys_pointer = this.selectedIndex;
    });
  },
  methods: {
    isSelectedOption(t) {
      return this.selectProperties ? this.selectProperties.every((e) => this.hasSameProperty(t, e)) : this.bindValueOnly ? this.selected === t[this.valueProp] : this.hasSameProperty(t) || this.selected === t;
    },
    hasSameProperty(t, e = this.valueProp) {
      if (t && this.selected && t[e] !== void 0 && this.selected[e] !== void 0) {
        const l = t[e], p = this.selected[e];
        return p === l || p == null && l == null;
      }
      return !1;
    },
    onChange({ target: t }) {
      if (t && t.value) {
        const e = this.dropdownOptions.find((l) => l[this.valueProp] === t.value);
        e && this.select(e);
      }
    },
    onEnter(t) {
      this.select(t);
    },
    toggle() {
      this.active ? this.close() : this.open();
    },
    open() {
      this.readonly || (this.active = !0, this.$refs.input.focus(), !this.firstTimeOpen && this.dropdownKeys_pointer !== -1 && (this.firstTimeOpen = !0, this.$nextTick(() => {
        this.dropdownKeys_scrollTo(this.dropdownKeys_pixelsToPointerTop());
      })));
    },
    close() {
      this.active = !1;
    },
    select(t) {
      const e = this.bindValueOnly ? t[this.valueProp] : t;
      this.selected !== e && (this.selected = e, this.$emit("update:modelValue", e)), this.close();
    }
  }
}, E = ["required", "name"], L = ["selected"], j = ["selected"], F = ["value"], z = ["for"], A = { class: "select-input" }, R = ["value", "name", "tabindex", "placeholder"], U = {
  key: 1,
  class: "error-text"
}, G = {
  key: 2,
  class: "assistive-text"
}, H = { class: "loading" }, J = { class: "dropdown-menu-list" }, Q = ["id", "data-qa", "onMousedown", "onMouseover"], W = { class: "status empty" };
function X(t, e, l, p, b, s) {
  const g = w("Spinner"), V = w("Icon"), k = w("Dropdown");
  return d(), a("div", {
    class: u(["select-field", {
      active: b.active,
      "has-selected": s.hasSelected,
      readonly: l.readonly,
      error: s.showInvalid
    }])
  }, [
    S(k, {
      legacy: "",
      "is-open": b.active,
      "pin-bottom": l.pinBottom,
      onClose: s.close
    }, {
      menu: O(() => [
        o("div", null, [
          m(o("div", H, [
            S(g)
          ], 512), [
            [c, l.loading]
          ]),
          e[18] || (e[18] = r()),
          m(o("ul", J, [
            (d(!0), a(P, null, K(s.dropdownOptions, (n, v) => m((d(), a("li", {
              id: n[l.valueProp] || n,
              key: v,
              class: u(["dropdown-menu-item", [n.className ? n.className : "", { selected: s.isSelectedOption(n), highlight: v === t.dropdownKeys_pointer, dense: l.dense }]]),
              "data-qa": n[l.labelProp],
              onMousedown: i((C) => s.select(n), ["prevent", "stop"]),
              onMouseover: (C) => t.dropdownKeys_pointer = v
            }, f(n[l.labelProp] || n), 43, Q)), [
              [c, s.dropdownOptions.length > 0]
            ])), 128)),
            e[17] || (e[17] = r()),
            m(o("li", null, [
              o("span", W, f(l.noResultsLabel || p.i18n.messages["select.empty.results"]), 1)
            ], 512), [
              [c, s.dropdownOptions.length === 0]
            ])
          ], 512), [
            [c, !l.loading]
          ])
        ])
      ]),
      default: O(() => [
        o("div", {
          class: u(["select-container", { "no-label": !l.label }])
        }, [
          o("select", {
            tabindex: "-1",
            required: l.required,
            name: l.name,
            class: "visually-hidden",
            onChange: e[0] || (e[0] = (...n) => s.onChange && s.onChange(...n))
          }, [
            o("option", {
              value: "",
              selected: s.invalid
            }, f(s.invalid), 9, L),
            e[10] || (e[10] = r()),
            o("option", {
              value: "selected",
              selected: !s.invalid
            }, null, 8, j),
            e[11] || (e[11] = r()),
            (d(!0), a(P, null, K(s.dropdownOptions, (n) => (d(), a("option", {
              key: n[l.valueProp],
              value: n[l.valueProp]
            }, null, 8, F))), 128))
          ], 40, E),
          e[13] || (e[13] = r()),
          l.label ? (d(), a("label", {
            key: 0,
            for: l.name,
            class: u({ required: l.required })
          }, f(l.label), 11, z)) : y("", !0),
          e[14] || (e[14] = r()),
          o("div", A, [
            o("input", {
              ref: "input",
              type: "text",
              readonly: "true",
              value: s.selectedLabel,
              name: l.name,
              tabindex: s.tabIndex,
              class: u({ invalid: s.showInvalid }),
              placeholder: l.placeholder,
              onKeydown: [
                e[1] || (e[1] = h(i((...n) => t.dropdownKeys_arrowUp && t.dropdownKeys_arrowUp(...n), ["prevent"]), ["up"])),
                e[2] || (e[2] = h(i((...n) => t.dropdownKeys_arrowDown && t.dropdownKeys_arrowDown(...n), ["prevent"]), ["down"])),
                e[3] || (e[3] = h((...n) => t.dropdownKeys_enter && t.dropdownKeys_enter(...n), ["tab"])),
                e[4] || (e[4] = h(i((...n) => t.dropdownKeys_enter && t.dropdownKeys_enter(...n), ["prevent", "stop", "self"]), ["enter"])),
                e[5] || (e[5] = h(i((...n) => s.close && s.close(...n), ["stop"]), ["esc"]))
              ],
              onFocus: e[6] || (e[6] = i((...n) => s.open && s.open(...n), ["stop", "prevent"])),
              onMousedown: e[7] || (e[7] = i((...n) => s.toggle && s.toggle(...n), ["stop", "prevent"])),
              onBlur: e[8] || (e[8] = i((...n) => s.close && s.close(...n), ["prevent"]))
            }, null, 42, R),
            e[12] || (e[12] = r()),
            o("div", {
              class: "input-chevron",
              onMousedown: e[9] || (e[9] = i((...n) => s.toggle && s.toggle(...n), ["stop", "prevent"]))
            }, [
              l.loading ? (d(), B(g, {
                key: 0,
                size: 24
              })) : (d(), B(V, {
                key: 1,
                name: "chevron-down"
              }))
            ], 32)
          ]),
          e[15] || (e[15] = r()),
          s.showError ? (d(), a("span", U, [
            I(t.$slots, "error", {}, void 0, !0)
          ])) : y("", !0),
          e[16] || (e[16] = r()),
          t.$slots.help ? (d(), a("span", G, [
            I(t.$slots, "help", {}, void 0, !0)
          ])) : y("", !0)
        ], 2),
        e[19] || (e[19] = r())
      ]),
      _: 3
    }, 8, ["is-open", "pin-bottom", "onClose"])
  ], 2);
}
const de = /* @__PURE__ */ M(_, [["render", X], ["__scopeId", "data-v-3c1ecbdc"]]);
export {
  de as default
};
//# sourceMappingURL=design-system.es93.js.map
